import { EventApi, MenuApi } from 'api'
import { TopLevelPage, ModelGrid } from 'ui'
import { SmartButtonFeedList } from 'ui/smart-buttons'
import { withErrorBoundary, connected } from 'shared'

const menuPageKey = (menuId) => `menu-page:${menuId}`
const LAST_MENU_ID_KEY = 'menu-last-id'
const savedMenuPage = (menuId) => {
  let page = sessionStorage.getItem(menuPageKey(menuId))
  return page ? Number(page) : null
}
const saveMenuPage = (menuId, page) => {
  sessionStorage.setItem(menuPageKey(menuId), page)
}
const initialMenuPage = (menuId) => {
  let lastMenuId = sessionStorage.getItem(LAST_MENU_ID_KEY)
  if (lastMenuId != menuId) {
    sessionStorage.setItem(LAST_MENU_ID_KEY, menuId)
    saveMenuPage(menuId, 1)
    return 1
  }
  return savedMenuPage(menuId) || 1
}
const resetMenuPagination = (menuId) => {
  sessionStorage.setItem(LAST_MENU_ID_KEY, menuId)
  saveMenuPage(menuId, 1)
  MenuApi.reset('show', { actionId: `${menuId}` })
}

class MenuItems extends Component {
  static propTypes = {
    match: PropTypes.object,
  }

  constructor(props) {
    super(props)
    let { menuId } = props.match.params
    this.state = { currentPage: initialMenuPage(menuId) }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.menuId != this.props.match.params.menuId) {
      let { menuId } = this.props.match.params
      resetMenuPagination(menuId)
      this.setState({ currentPage: 1 })
    }
  }

  goToPage = (page) => {
    if (page >= 1) {
      let { menuId, id } = this.props.match.params
      saveMenuPage(menuId, page)
      this.setState({ currentPage: page })
      if (id)
        application.go(`menu/${menuId}`)
    }
  }

  render() {
    let { menuId, id, subId } = this.props.match.params
    let { currentPage } = this.state
    let menu = application.state.getModel(`menu:${menuId}`)
    let isCustomMenu = Number(menuId) > 0 || menuId == 'saved_amenities'
    let models = isCustomMenu ?
      MenuApi.kick('show', { id: menuId, page: currentPage, limit: 8 }, {actionId: `${menuId}`}) :
      EventApi.kick(menuId)

    let totalPages = 1
    if (isCustomMenu && models && models.length > 0) {
      let lastIndex = models.length - 1
      if (models[lastIndex].totalPages) {
        totalPages = models[lastIndex].totalPages
        models = models.slice(0, lastIndex)
      }
    }

    let base = `menu/${menuId}`
    let modelId = subId || id

    return (
      <TopLevelPage className="CustomMenu" modelId={modelId} base={id ? `${base}/${id}` : base} returnUrl={base} pageTitle={menu?.name}>
        <ModelGrid models={models} base={base} pageTitle={menu?.name} />
        {isCustomMenu && totalPages > 1 &&
          <div className="row justify-content-center mt-4 custom-menu-pagination">
            <div className="col-12">
              <nav aria-label="Pagination">
                <ul className="pagination">
                  <li className={classNames('page-item', {disabled: currentPage == 1})}>
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => this.goToPage(currentPage - 1)}
                      disabled={currentPage == 1}
                    >
                      Previous
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, index) => (
                    <li className={classNames('page-item', {active: currentPage == index + 1})} key={index}>
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => this.goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}
                  <li className={classNames('page-item', {disabled: currentPage == totalPages})}>
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => this.goToPage(currentPage + 1)}
                      disabled={currentPage == totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        }
      </TopLevelPage>
    )
  }
}

export default withErrorBoundary(connected(MenuItems))
